var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrial(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 49,
    viewBox: "0 0 46 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.445312 8.2085C0.445312 3.79022 4.02703 0.208496 8.44531 0.208496H37.4937C41.9119 0.208496 45.4937 3.79022 45.4937 8.2085V40.1946C45.4937 44.6129 41.9119 48.1946 37.4937 48.1946H8.44532C4.02704 48.1946 0.445312 44.6129 0.445312 40.1946V8.2085Z",
    fill: "#90AAD6",
    fillOpacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6052 27.7205C31.9692 29.2246 30.9745 30.5499 29.708 31.5807C28.4414 32.6115 26.9416 33.3163 25.3398 33.6336C23.7379 33.9509 22.0827 33.8709 20.5189 33.4007C18.9551 32.9305 17.5302 32.0843 16.369 30.9363C15.2077 29.7882 14.3453 28.3731 13.8573 26.8147C13.3693 25.2564 13.2704 23.6022 13.5693 21.9968C13.8683 20.3914 14.556 18.8837 15.5722 17.6055C16.5885 16.3273 17.9024 15.3174 19.3991 14.6643",
    stroke: "#092147",
    strokeWidth: 1.99942,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3955 23.8318C33.3955 22.519 33.137 21.219 32.6346 20.0061C32.1322 18.7932 31.3958 17.6911 30.4675 16.7628C29.5391 15.8345 28.4371 15.0981 27.2242 14.5957C26.0113 14.0933 24.7113 13.8347 23.3984 13.8347V23.8318H33.3955Z",
    stroke: "#092147",
    strokeWidth: 1.99942,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrial);
export default __webpack_public_path__ + "static/media/trial.fef509c80d908b83dcd8c2bc5718c538.svg";
export { ForwardRef as ReactComponent };